<template>
  <v-card id="judgmenttagging"
    flat class="rsidecard mb-4 mr-3 pb-3"
    max-width="350" min-width="250" width="100%"
  >

    <v-card-title class="pb-1 align-start mb-2">
      <h5 class="wdgt-title mb-0">{{$t('synopsis.title')}}</h5>
      <v-spacer></v-spacer>
      <v-tooltip left max-width="250" color="liiblack lighten-1">
        <template v-slot:activator="{ on, attrs }">
          <router-link to="/news#tagging" >
            <span class="beta-tag link--text" v-bind="attrs" v-on="on" >
              {{$t('btntxt.newfeature')}}
            </span>
          </router-link>
        </template>
        <span>{{$t('synopsis.beta_hint')}}</span>
      </v-tooltip>
    </v-card-title>

    <v-card-text class="pb-3">
      <div v-show="!showResults">
        <p class="help-text mb-2">{{$t('synopsis.desc') + $t('synopsis.lang_support')}}</p>

        <!--view toogle btn-->
        <v-btn-toggle
          v-model="showHierarchy"
          mandatory
          dense x-small tile 
          class="d-flex mb-2"
          active-class="navlink--text link--icon font-weight-bold"
        >
          <v-btn x-small dense class="flex-grow-1" text @click="showHierarchy = false" >
            <v-icon small class="mr-2">mdi-view-compact-outline</v-icon>
            {{$t('synopsis.hide_tree')}}
          </v-btn>
          <v-btn x-small dense class="flex-grow-1" @click="showHierarchy = true">
            <v-icon small class="mr-2">mdi-file-tree</v-icon>
            {{$t('synopsis.show_tree')}}
          </v-btn>
        </v-btn-toggle>

        <!--tag cloud compact view-->
        <v-chip-group v-if="!showHierarchy" column multiple>
          <v-menu v-for="tag in leaves" :key="tag.id" offset-y>
            <template v-slot:activator="{on}">
              <v-chip 
                label small :ripple="false"
                :color="getTagColor(tag)"
                v-on="on"
                class="my-1 px-2 font-weight-bold no-active tag"
                :class="tagClass(tag.id)"
              >
                {{tag.name}}
              </v-chip>
            </template>
            
            <!--selection menu-->
            <v-list dense class="white">
              <v-list-item
                @click="includeTag(tag)"
              >
                {{$i18n.t('synopsis.include')}}
              </v-list-item>

              <v-list-item
                @click="excludeTag(tag)"
              >
                {{$i18n.t('synopsis.exclude')}}
              </v-list-item>
            </v-list>
          </v-menu>
        </v-chip-group>

        <!--tree view--->
        <v-treeview
          v-if="showHierarchy && tagTree.length>0"
          :items="tagTree"
          open-all dense
          class="tag-tree mt-2"
        >
          <template v-slot:label="{item, leaf}">
            <div>
              <div v-if="leaf">
                <v-chip-group column multiple>
                  <v-menu v-for="tag in item.tags" :key="tag.id" offset-y>
                    <template v-slot:activator="{on}">
                      <v-chip 
                        label small
                        :color="getTagColor(tag)"
                        v-on="on"
                        class="mt-0 mb-1 mr-1 px-2 font-weight-bold no-active tag"
                        :class="tagClass(tag.id)"
                      >{{tag.name}}</v-chip>
                    </template>
                    
                    <!--selection menu-->
                    <v-list dense>
                      <v-list-item
                        @click="includeTag(tag)"
                      >
                        {{$i18n.t('synopsis.include')}}
                      </v-list-item>

                      <v-list-item
                        @click="excludeTag(tag)"
                      >
                        {{$i18n.t('synopsis.exclude')}}
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-chip-group>
              </div>

              <div v-else class="tree-inner" :class="item.level===0 ? 'outermost-level' : 'inner-level'">
                {{item.name}}
              </div>

            </div>
          </template>
        </v-treeview>
        
        <div v-show="showTagExplain">
          <p class="tag-explain">
            <v-chip label small :ripple="false"
              color="link lighten-4"
              class="px-2 font-weight-bold no-active">
              {{$t('synopsis.tag_dark')}}
            </v-chip>
            {{$t('synopsis.tag_dark_exp')}}</p>
          <p class="tag-explain"> 
            <v-chip label small :ripple="false"
              color="link lighten-5"
              class="px-2 font-weight-bold no-active">
              {{$t('synopsis.tag_light')}}
            </v-chip>
            {{$t('synopsis.tag_light_exp')}}
          </p>
        </div>
      </div>

      <!--selected tags-->
      <div v-if="selectedTags.length>0">
        <v-divider v-if="!showResults" class="mt-2"></v-divider>
        <h4 class="wdgt-subtitle mt-1 mb-0 darkgrey--text text--darken-3">{{$t('synopsis.selected')}}</h4>
        
        <p v-if="!showResults" class="help-text mt-1 mb-2">{{$t('synopsis.search_desc')}}</p>
        <v-chip-group column class="d-flex flex-wrap selected-tag-gp">
          <v-chip 
            v-for="tag in selectedTags" :key="tag.id"
            label small :color="getTagColor(tag)" :ripple="false"
            class="pr-1 pl-0 py-0 no-active mb-0 mr-1"
          >
            <div class="flex-stretch white--text px-1 py-1" :class="selectedTagClass(tag.id)" >
              {{tag.include ? $i18n.t('synopsis.include') : $i18n.t('synopsis.exclude')}} 
            </div>
            <span class="font-weight-bold ml-1"> {{tag.name}} </span>
            <v-icon v-if="!showResults" 
              class="ml-1" small
              @click="resetTag(tag)"
            >mdi-close-circle</v-icon>
          </v-chip>
        </v-chip-group>
      </div>

      <!--search button-->
      <v-btn
        v-if="!showResults"
        dense block 
        :elevation="selectedTags.length>0? '2':'0'"
        :disabled="selectedTags.length>0? false:true"
        color="primary text--white"
        class="mt-3"
        @click="searchRelevant"
      >
        <v-icon small class="mr-4"> mdi-magnify </v-icon> 
        {{$i18n.t('btntxt.search')}}
      </v-btn>


      <!--judgments -->
      <div v-if="showResults">
        <v-divider class="mt-2"></v-divider>
        <h4 class="wdgt-subtitle mt-1 mb-2 darkgrey--text text--darken-3">{{$t('synopsis.result')}}</h4>
        <div class="judgments-container mb-2">
          <v-card
            v-for="judgment in judgments" :key="judgment.neutral" 
            class="judgment-result mb-2 pl-2 pr-1 py-2 mr-1" 
            flat
            :to="get_case_params(judgment.neutral)"
            target="_blank"
            >
            <p class="resulttitle mb-1" v-html="judgment.title" />
            <span class="darkgrey--text">{{judgment.subtitle}}</span> <br>
            <span>{{judgment.date}}</span>

             <v-chip-group column multiple>
              <v-chip v-for="tagmatch in judgment.match" :key="tagmatch" 
                label small :ripple="false"
                color="link lighten-5"
                class="mt-1 mb-0 mr-1 px-2 font-weight-bold no-active"
              > <!--:color="getTagColor(tagmatch)"-->
                {{tagmatch}}
              </v-chip>
            </v-chip-group>
          </v-card>

          <!-- overlay -->
          <v-overlay :value="overlay" absolute class="d-print-none">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </div>
     
      
      <!--back to trees button-->
      <v-btn
        v-if="showResults"
        dense block
        elevation="0"
        color="liiblack white--text"
        class="mt-4"
        @click="returnToTags"
      >
        <v-icon small class="mr-4"> mdi-chevron-left </v-icon> 
        {{$i18n.t('synopsis.return_to_tags')}}
      </v-btn>


    </v-card-text>
  </v-card>
</template>
<script>
  import api from '@/scripts/api'
  import datehelper from '@/scripts/datehelper'
  export default {
    name: 'JudgmentTagging',
    props: {
      primaryTags: {type: Array, required: true},
      secondaryTags: {type: Array, required: true}
    },
    data(){
      return {
        showHierarchy: false,
        showResults: false,
        tagTree: [],
        leaves: [],
        judgments: [],
        overlay: false,
        showBetaTag: false,
        showTagExplain: false,
      }
    },
    watch: {
      primaryTags: {
        handler: function(){
          this.createTagTree()
        },
        deep: true
      },
      secondaryTags: {
        handler: function(){
          this.createTagTree()
        },
        deep: true
      }
    },
    methods: {
      includeTag(tag){
        var selectedTag = this.leaves.find(leaf => leaf.id === tag.id)
        selectedTag.include = true
        selectedTag.exclude = false
      },
      excludeTag(tag){
        var selectedTag = this.leaves.find(leaf => leaf.id === tag.id)
        selectedTag.include = false
        selectedTag.exclude = true
      },
      resetTag(tag){
        var selectedTag = this.leaves.find(leaf => leaf.id === tag.id)
        selectedTag.include = false
        selectedTag.exclude = false
      },
      returnToTags(){
        this.showResults = false
        this.judgments = []
      },
      get_case_params(neutral){
        let match = /\[([\d]+)\]\s([A-Za-z]+)\s(\d+)/.exec(neutral)
        if(match){
          return {
            'name': 'case',
            'params': {
              'abbr': match[2].toLowerCase(),
              'year': match[1],
              'num': match[3] 
            }
          }
        }
        return null
      },
      async searchRelevant(){
        const target_tags = this.selectedTags.filter(tag => tag.include).map(tag => tag.fullPath[tag.fullPath.length - 1])
        const exclusion_tags = this.selectedTags.filter(tag => tag.exclude).map(tag => tag.fullPath[tag.fullPath.length - 1])
        
        this.showResults = true
        this.overlay = true
        try {
          const res = await api.get_ranked_judgment_by_tags(target_tags, exclusion_tags)
          this.judgments = res.map(j => {return {
            title: j.title,
            subtitle: `${j.neutral}; ${j.act}`,
            date: datehelper.display_date(j.date),
            neutral: j.neutral,
            match: j.match
          }})  // Some fields are hidden. May dispay them in future design
        } catch (err) {
          console.error(err)
        } finally {
          this.overlay = false
        }
      },
      createTagTree(){
        this.showResults = false
        this.judgments = []

        var tags = []
        const seperatingChar = ' — '
        this.primaryTags.forEach(tagArr => {
          const _t = [...tagArr].reverse()
          tags.push({
            node: {
              name: tagArr[0],  // leaf
              fullPath: [..._t],
              isPrimary: true,
            },
            _curPath: [..._t].slice(0, -1),  // for tree generation
          })
        })
        this.secondaryTags.forEach(tagArr => {
          const _t = [...tagArr].reverse()
          tags.push({
            node: {
              name: tagArr[0],
              fullPath: [..._t],
              isPrimary: false,
            },
            _curPath: [..._t].slice(0, -1),
          })
        })

        const uid = function* (){
          let i = 0
          while(true) yield ++i
        }()

        this.leaves = []

        const mergePaths = (_tags) => {
          var d = {}
          var _tree = []

          _tags.forEach(_tag => {
            if(_tag._curPath.length === 0){  // leaf node
              var leaf = _tree.find(node => node.isLeafParent)
              if(!leaf){
                leaf = {
                  id: uid.next().value,
                  isLeafParent: true,
                  tags: []
                }
                _tree.push(leaf)
              }
              const _uid = uid.next().value
              leaf.tags.push({
                id: _uid,
                name: _tag.node.name,
                isPrimary: _tag.node.isPrimary
              })
              this.leaves.push({
                id: _uid,
                ..._tag.node,
                include: false,
                exclude: false
              })
            } else {
              const curRoot = _tag._curPath.shift()
              d[curRoot] = (curRoot in d) ? [...d[curRoot], _tag] : [_tag]
            }
          })

          for (var i of Object.keys(d)){
            var k = mergePaths(d[i])
            if(k.length === 1 && k[0].children){  // contracting edges
              _tree.push({
                id: uid.next().value,
                name: `${i}${seperatingChar}${k[0].name}`,
                children: k[0].children
              })
            } else {
              _tree.push({
                id: uid.next().value,
                name: i,
                children: k
              })
            }
          }
          return _tree
        }

        const markLevel = (_tags, curLevel=0) => {
          _tags.forEach(_tag => {
            _tag.level = curLevel
            if(_tag.children) markLevel(_tag.children, curLevel + 1)
          })
        }

        var _tree = mergePaths(tags)
        markLevel(_tree)
        this.tagTree = _tree
        this.leaves.sort((a, b) => b.isPrimary - a.isPrimary)
      },
      getTagColor(tag){
        //return tag.isPrimary ? 'link lighten-4' : 'link lighten-5' // currently do not differentiate primary and secondary tags
        return 'link lighten-5'  
      },
      tagClass(id){
        const selectedTag = this.leaves.find(leaf => leaf.id === id)
        if(selectedTag.include) return 'included-tag'
        if(selectedTag.exclude) return 'excluded-tag'
        return 'unselected-tag'
      },
      selectedTagClass(id){
        const selectedTag = this.leaves.find(leaf => leaf.id === id)
        if(selectedTag.include) return 'selected-included-tag'
        if(selectedTag.exclude) return 'selected-excluded-tag'
        return 'unselected-tag'
      },
    },
    computed: {
      selectedTags(){
        return this.leaves.filter(leaf => leaf.include || leaf.exclude)
      }
    },
    mounted(){
      this.createTagTree()
    }
  }
</script>

<style lang="scss" scoped>
  .help-text{
    line-height: 0.98rem;
    font-size: 0.8rem;
  }
  .tag-explain-prompt{
    opacity: 0.8;
  }
  .tag-explain-prompt:hover{
    opacity: 1;
    transition: 0.1s;
    text-decoration: underline 1px solid var(--v-link-base);
    text-underline-offset: 2px;
  }
  .tag-explain{
    line-height: 1.35rem;
    font-size: 0.8rem;
    margin-top: 8px;
    margin-bottom: 0px;
    padding-left: 22px ;
    color: rgba(0, 0, 0, 0.9);
    text-indent: -2px;
    
  }

  /*treeview steup*/
  .tree-inner{
    font-size: 10pt;
  }
  .outermost-level{
    font-weight: bold;
    color: var(--v-darkgrey-darken1);
  }
  .inner-level{
    font-style: italic;
    color: var(--v-darkgrey-darken1);
  }
  .inner-level::before{
    font-style: normal;
    content: '└';
    padding-left: 6px;
  }
 ::v-deep {
    .v-treeview--dense .v-treeview-node__root, .v-treeview-node__content{
      min-height: 0px ;
      padding-left: 0px ;
      margin-left: 0px;
    }
    .v-treeview-node__root > .v-treeview-node__level { 
      width: 12px ; /*control indentation*/
    }
    .v-treeview-node__root > .v-treeview-node__level:first-child { 
      width: 0px ; /*control indentation*/
    }
    .v-treeview-node__toggle{
      display: none;
    }
    .v-slide-group__content{
      padding-top: 0.5px; /*vertical spacing*/
      padding-left: 0.5px; /*show the border*/
    }
    
    .v-treeview-node__label{
      white-space: normal !important; /*show all text from outermost node label, see /en/cases/hkdc/2007/422 */
      line-height: 1.05rem;
      padding-bottom: 4px;
    }
 }

  /*chip selection*/
  .tag:hover, .tag:focus{
    /*background: linear-gradient( rgba(29, 107, 224, 0.2),  rgba(29, 107, 224, 0.2) );*/
    outline: 1px solid var(--v-link-base);
  }
  .v-chip.included-tag{
    border-left: 4px solid #00897B !important;
  }
  .v-chip.excluded-tag{
    border-left: 4px solid var(--v-warning-base) !important;
  }
  .selected-included-tag{
    background: #00897B !important;
  }
  .selected-excluded-tag{
    background: var(--v-warning-base) !important;
  }
  ::v-deep { 
    .v-slide-group__wrapper {
      overflow: visible !important;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
  }
  /*.v-chip.unselected-tag{
    border-left: 3px solid transparent !important;
  }*/  /*prevent moving by selection border */
  
  /*remove chip active class*/
  .v-chip.no-active{
    color: liiblack !important;
  }
  .v-chip.no-active::before{                                                                     
    opacity: 0 !important;
  }

  /*drop down menu*/
  .theme--light.v-list-item{
    color: var(--v-link-base) !important;
  }
  .v-list--dense .v-list-item{
    font-size: 0.9rem !important;
    min-height: 36px !important;
  }

  /*judgments*/
  .judgment-result{
    border-left: 5px solid var(--v-l_case-base);
    background-color: var(--v-lsidebg-base);
  }
  .judgment-result:hover{
    background-color: var(--v-lsidebg-darken1);
    transition: 0.1s;
  }
  .resulttitle{
    font-weight: 600;
    line-height: 0.95rem;
  }

  /*scroll bar for judgment*/
  .judgments-container{
    max-height: 440px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .judgments-container::-webkit-scrollbar {
    width: 6px;
    background-color: none;
  }
  .judgments-container::-webkit-scrollbar-track {
    background-color: none;
  }
  .judgments-container::-webkit-scrollbar {
    width: 6px;
    background-color: none;
  }
  .judgments-container::-webkit-scrollbar-thumb {
    background-color: var(--v-rsidebg-darken1);
  }

</style>